<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Incidencias</span>
            <v-spacer></v-spacer>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filterIncidencias"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  hide-default-footer
                  dense
                >
                  <template v-slot:item.estatus="{ item }">
                    <v-chip color="primary" small dark v-if="item.estatus == 0"
                      >Pendiente</v-chip
                    >
                    <v-chip color="green" small dark v-if="item.estatus == 1"
                      >Aceptado</v-chip
                    >
                    <v-chip color="balck" small dark v-if="item.estatus == 2"
                      >Rechazado</v-chip
                    >
                  </template>

                  <template v-slot:item.historial="{ item }">
                    <v-btn
                      color="primary"
                      dark
                      class="text-capitalize rounded"
                      style="text-transform: none"
                      @click="
                        (idhistorial = item),
                          (dialog_mensaje_rechazo = true),
                          getMensajesRechazo()
                      "
                      small
                      tile
                    >
                      Responder
                    </v-btn>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="deleteItem(item)" color="error">
                      mdi-delete
                    </v-icon>
                  </template>

                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize" small>
                      Actualizar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  :items="alumnos"
                  v-model="editedItem.idusuarioerp"
                  label="Alumno"
                  outlined
                  hide-details
                  dense
                  item-text="alumno"
                  item-value="iderp"
                  @change="infoAlumnos"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-autocomplete
                  :items="filterReglas"
                  v-model="editedItem.idreglamento"
                  label="Regla"
                  outlined
                  hide-details
                  dense
                  item-text="regla"
                  item-value="idreglamento"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.notas"
                  label="Nota (Opcional)"
                  outlined
                  hide-details
                  dense
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
          <v-btn color="blue darken-1" class="elevation-6" dark @click="save">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-card class="elevation-0" height="100%" style="display: table">
            <div
              class="text-h6"
              style="display: table-cell; vertical-align: middle"
            >
              <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la
              incidencia?
              <v-card-actions class="pt-6">
                <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                <v-btn
                  color="error"
                  text
                  large
                  class="mr-2"
                  @click="closeDelete()"
                >
                  No, cancelar
                </v-btn>
                <!-- Guardar la información  -->
                <v-btn
                  color="#5C5C5C"
                  dark
                  class="elevation-6"
                  large
                  @click="deleteItemConfirm()"
                  >Si</v-btn
                >
              </v-card-actions>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_mensaje_rechazo" max-width="1000px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1"><b>Respuesta del alumno</b></span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID:</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row v-for="(item, index) in this.mensajes" :key="index">
            <v-col cols="12">
              <v-textarea
                v-model="item.nota"
                :id="'motivo_salida_' + index"
                label="Motivo del rechazo"
                outlined
                hide-details
                dense
                auto-grow
                readonly
                style="max-width: 900px; margin-right: auto"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.nota_respuesta"
                :id="'motivo_salida_' + index"
                label="Respuesta..."
                outlined
                hide-details
                dense
                auto-grow
                readonly
                style="max-width: 900px; margin-left: auto"
                :class="{ 'd-none': !item.nota_respuesta }"
              ></v-textarea>
            </v-col> </v-row
          ><br />
          <v-row
            style="border: 1px solid gray; padding: 2px; border-radius: 5px"
            v-if="idhistorial.estatus == 0 || idhistorial.estatus == 2"
          >
            <v-col cols="12" :style="{ paddingTop: '10px' }">
              <v-textarea
                v-model="editedItem2.mensaje"
                label="Escriba su mensaje..."
                outlined
                hide-details
                dense
                auto-grow
                :readonly="idhistorial.estatus != 2"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="
              (dialog_mensaje_rechazo = false), (editedItem2.mensaje = '')
            "
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            v-if="idhistorial.estatus == 2"
            @click="enviarMensajeRespuesta()"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import carga from "@/components/alertas/Loader.vue";

import validarErrores from "@/mixins/validarErrores";

import Avataaars from "vuejs-avataaars";

const base64 = require("base-64");

export default {
  mixins: [validarErrores],

  components: {
    Alerta,
    carga,
    Avataaars,
  },

  data: () => ({
    respuestaAlerta: false,

    loader: true,
    cargar: false,
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    listaalumnos: [],
    model: null,

    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "ID", align: "start", value: "idincidencias" },
      { text: "Alumno", value: "nombre_completo" },
      { text: "Regla", value: "regla" },
      { text: "Notas", value: "notas" },
      { text: "Estatus", value: "estatus" },
      { text: "Responder", value: "historial" },
      { text: "Eliminar", value: "actions", sortable: false },
    ],
    incidencias: [],
    editedIndex: -1,
    editedItem: {
      idincidencia: "",
      idreglamento: "",
      regla: "",
      deleted: 0,
      idcurso: 0,
      idalumno: 0,
      notas: "",
      idusuarioerp: 0,
      estatus: 0,
    },
    defaultItem: {
      idincidencia: "",
      idreglamento: "",
      regla: "",
      deleted: 0,
      idcurso: 0,
      idalumno: 0,
      notas: "",
      idusuarioerp: 0,
      estatus: 0,
    },

    dialogSuccess: false,
    overlay: false,
    dialogError: false,
    error: "",
    successMensaje: "",
    errorBack: false,
    textoCopiado: "COPIAR",
    idcurso: 0,
    info: 0,

    alumnos: [],
    reglas: [],
    cursosEscuela: [],
    editedItem2: {
      mensaje: "",
    },
    mensajes: [],
    dialog_mensaje_rechazo: false,
    idhistorial: [],
    // tabla
    search: "",
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
  }),

  computed: {
    ...mapGetters("login", ["getGrupo", "getUsuarioLMS"]),

    formTitle() {
      return this.editedIndex === -1
        ? "Agregar Incidencia"
        : "Editar Incidencia";
    },

    filterIncidencias() {
      if (this.ciclo) {
        return this.incidencias.filter((el) => {
          return el.id_ciclo == this.ciclo;
        });
      } else {
        return this.incidencias;
      }
    },

    filterReglas() {
      if (this.info) {
        return this.reglas.filter((el) => {
          return el.idcurso == this.info;
        });
      } else {
        return this.reglas;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    "editedItem.escuela"(val) {
      this.cursosEscuela = this.cursos.filter((el) => {
        return el.escuela == val;
      });
    },
  },

  created() {
    this.initialize();
    this.getAlumnos();
    this.getReglas();

    if (this.getGrupo.grupo.grupo_largo.match("TEENS")) {
      this.info = 3;
    }

    if (this.getGrupo.grupo.grupo_largo.match("KIDS")) {
      this.info = 4;
    }
  },

  methods: {
    initialize() {
      this.incidencias = [];
      this.overlay = true;

      let payload = {
        id_grupo: this.getGrupo.grupo.id,
      };

      this.$http
        // .get("incidencias.get.incidencias")
        .get(`incidencias.get.incidencias/${payload.id_grupo}`)
        .then((response) => {
          this.incidencias = response.body;
          console.log(this.incidencias)
          this.overlay = false;
        })
        .catch((error) => {
          // INdicamos que hay un error en el back
          if (error.body.message) {
            this.error = error.body.message;
          } else {
            this.error = error.body;
          }
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });
    },
    getReglas() {
      this.reglas = [];
      this.overlay = true;
      this.$http
        .get("reglamento.get.reglamento")
        .then((response) => {
          this.reglas = response.body;
          this.overlay = false;
        })
        .catch((error) => {
          //Indicamos que hay un error en el back
          if (error.body.message) {
            this.error = error.body.message;
          } else {
            this.error = error.body;
          }
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });
    },

    editItem(item) {
      this.editedIndex = this.incidencias.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.incidencias.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      // Lo mandapos por el EP
      this.editedItem.deleted = 1;
      this.$http
        .put("incidencias.update/" + this.editedItem.idincidencias)
        .then((response) => {
          this.dialogSuccess = true;
          this.overlay = false;
          this.closeDelete();
          this.initialize();
        })
        .catch((error) => {
          // INdicamos que hay un error en el back
          if (error.body.message) {
            this.error = error.body.message;
          } else {
            this.error = error.body;
          }
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      //   if (this.editedItem.regla == "") {
      //     this.error = "Favor de llenar todos los campos";
      //     this.errorBack = false;
      //     this.overlay = false;
      //     this.dialogError = true;
      //     return;
      //   }
      if (this.editedIndex > -1) {
        // Activamos el loader
        this.overlay = true;
        this.editedItem.deleted = 0;
        // Lo mandapos por el EP
        this.$http
          .put(
            "reglamento.escuela.update/" + this.editedItem.idreglamento,
            this.editedItem
          )
          .then((response) => {
            this.dialogSuccess = true;
            this.initialize();
            this.overlay = false;
          })
          .catch((error) => {
            // INdicamos que hay un error en el back
            if (error.body.message) {
              this.error = error.body.message;
            } else {
              this.error = error.body;
            }
            this.errorBack = true;
            this.overlay = false;
            this.dialogError = true;
          });
      } else {
        // Activamos el loader
        this.overlay = true;
        // Lo mandapos por el EP
        this.$http
          .post("incidencias.add.incidencia", this.editedItem)
          .then((response) => {
            this.dialogSuccess = true;
            this.initialize();
            this.overlay = false;
          })
          .catch((error) => {
            // INdicamos que hay un error en el back
            if (error.body.message) {
              this.error = error.body.message;
            } else {
              this.error = error.body;
            }
            this.errorBack = true;
            this.overlay = false;
            this.dialogError = true;
          });
      }
      this.close();
    },

    copiarPortapapeles() {
      navigator.clipboard
        .writeText(this.error)
        .then(() => {
          this.textoCopiado = "COPIADO";
        })
        .catch((err) => {
          console.log("Something went wrong", err);
        });
    },

    //Trae la informacion de toda la fila de alumnos en "Agregar Incidencia"
    infoAlumnos() {
      const alumnoSeleccionado = this.alumnos.find(
        (alumno) => alumno.iderp === this.editedItem.idusuarioerp
      );

      this.info = alumnoSeleccionado.tipo_curso;
    },

    getAlumnos() {
      this.cargar = true;
      // Preparamos el id del teacher
      const id_grupo = base64.encode(this.getGrupo.grupo.id);
      // Hacemos la consulta
      this.$http
        .get("grupos.lista.alumnos/" + id_grupo)
        .then((response) => {
          this.alumnos = response.body;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    getMensajesRechazo() {
      this.cargar = true;
      this.mensajes = [];

      const payload = {
        idincidencias: this.idhistorial.idincidencias,
        iderp: this.idhistorial.iderp,
      };
      return this.$http
        .post("consultar.mensajes.rechazo.incidencias", payload)
        .then((response) => {
          this.mensajes = response.body;
          this.cargar = false;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    enviarMensajeRespuesta() {
      this.cargar = true;
      const payload = {
        nota_respuesta: this.editedItem2.mensaje,
        idincidencias: this.idhistorial.idincidencias,
        idincidencias2: this.idhistorial.idincidencias,
        iderp: this.idhistorial.iderp,
        iderp2: this.idhistorial.iderp,

        id: this.idhistorial.idincidencias,
        estatus: 0,
      };

      console.log(payload);
      return this.$http
        .post("update.incidencias.mensaje.respuesta", payload)
        .then((response) => {
          this.$http
            .post("update.estatus.incidencias", payload)
            .then((response) => {
              this.validarSuccess(response.body.message);
              this.cargar = false;
              this.dialog_mensaje_rechazo = false;
              this.initialize();
              this.editedItem2.mensaje = null;
            })
            .catch((error) => {
              this.validarError(error);
            })
            .finally(() => {
              this.cargar = false;
            });
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },
  },
};
</script>